import React from 'react';
import { TableListItemLeftCellStyled, TableListItemRightCellStyled, TableListItemRowStyled, TableListItemStyled, TableListStyled } from './style';
import { Box, Typography } from '@mui/material';

const columnsData = [
    {
        id: 'id',
        name: 'ID',

        hideCellValue: true,

        renderElement: (row, currentCellValue) => {
            return (
                <span>
                    {row.firstName}
                    <button>hello {currentCellValue}</button>
                </span>
            );
        },
    },
    { id: 'firstName', name: 'First name' },
    { id: 'lastName', name: 'Last name' },
    {
        id: 'age',
        name: 'Age',
        type: 'number',
        showSortIcon: true,
    },
];
const rowsData = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: 20 },
];

/**
 * TableList -  Table List shows table row items as list in mobile view
 * @param {*} param0
 * @returns
 */
function TableList({
    rows = rowsData,
    columns = columnsData,
    componentStyleProps = {
        tableListSx: {},
        tableListItemSx: {},
        tableListItemRowSx: {},
        tableListItemLeftCellSx: {},
        tableListItemRightCellSx: {},
    },
    showHeading = false,
    headingText = '',
}) {
    return (
        <TableListStyled
            sx={{
                ...componentStyleProps.tableListSx,
            }}
        >
            {showHeading && (
                <Box
                    padding={'16px 4px 10px 0px'}
                    sx={(theme) => ({
                        // borderBottom: `1px solid ${theme.palette.border.neutralPrimary}`,
                    })}
                >
                    <Typography component={'h2'} fontSize={'customFontSize.large'} fontWeight={'fontWeightSemiBold'}>
                        {headingText}
                    </Typography>
                </Box>
            )}
            {rows.map((cRow, index) => {
                return (
                    <TableListItemStyled
                        key={index}
                        sx={{
                            ...componentStyleProps.tableListItemSx,
                        }}
                    >
                        {columns.map((cColumn) => (
                            <TableListItemRowStyled
                                sx={{
                                    ...componentStyleProps.tableListItemRowSx,
                                }}
                            >
                                {!cColumn.hideLeftCell && (
                                    <TableListItemLeftCellStyled
                                        sx={{
                                            ...componentStyleProps.tableListItemLeftCellSx,
                                        }}
                                    >
                                        {cColumn?.name}
                                    </TableListItemLeftCellStyled>
                                )}

                                <TableListItemRightCellStyled
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-end',
                                        justifyContent: 'center',

                                        ...componentStyleProps.tableListItemRightCellSx,
                                        ...cColumn.rightCellSx,
                                    }}
                                >
                                    {!cColumn.hideCellValue && typeof cRow[cColumn.id] === 'string' && cRow[cColumn.id]} {cColumn.renderElement && cColumn.renderElement(cRow, cRow[cColumn.id])}
                                </TableListItemRightCellStyled>
                            </TableListItemRowStyled>
                        ))}
                    </TableListItemStyled>
                );
            })}
        </TableListStyled>
    );
}

export default TableList;
